export const uniqueLabels = (items) => {
  if (!Array.isArray(items)) return [];

  const seen = new Set();
  return items.reduce((result, item) => {
    const label = String(item ?? "").trim();
    const normalized = label.toLocaleLowerCase();
    if (!label || seen.has(normalized)) return result;
    seen.add(normalized);
    result.push(label);
    return result;
  }, []);
};
